<template>
  <div class="text-left p-1">
    <div class="mb-3">
      <strong>
        <a href="#" @click.prevent="clicked">
          {{ notification.condition_name }}
        </a>
      </strong>
      <toggle-button
        class="float-right"
        :sync="true"
        v-model="subscription.enabled"
        @change="setEnabledSubscription"
        :disabled="enableLoading"
      />
    </div>
    <b-collapse :id="`collapse-${notification.id}`" :visible="visible">
      <p>{{ notification.condition_description }}</p>
      <expression-group
        v-if="advancedView"
        :index="0"
        :depth="1"
        :query="notification.expression"
        :vars="varsByLink"
        class="vue-query-builder"
        :members="notification.members"
      />
      <template v-else>
        <member
          v-for="member in writableMembers"
          :key="`${member.id}-${member.value}`"
          :member="member"
          :vars="varsByLink"
          class="my-2"
        />
      </template>
      <p class="text-right" v-if="hasAdvanceMode">
        <a href="#" @click.prevent="toggleAdvancedView" >
          <span v-if="!advancedView">{{ $t('advanced-view') }}</span>
          <span v-else>{{ $t('simple-view') }}</span>
        </a>
      </p>
      <div class="mt-3 d-flex justify-content-center">
        <b-form-checkbox class="mr-1" v-model="subscription.email" name="check-button" button @change="setEmailSubscription">
          <font-awesome-icon icon="envelope" />
          <span class="mr-1 ml-1">Email</span>
          <b-spinner small v-if="emailLoading"></b-spinner>
          <font-awesome-icon v-else :icon="subscription.email ? 'check-circle' : ['far', 'circle']" />
        </b-form-checkbox>
        <b-form-checkbox v-model="subscription.push_notification" name="check-button" button @change="setPushSubscription">
          <font-awesome-icon icon="comment-alt" />
          <span class="mr-1 ml-1">Push notification</span>
          <b-spinner small v-if="pushLoading"></b-spinner>
          <font-awesome-icon v-else  :icon="subscription.push_notification ? 'check-circle' : ['far', 'circle']" />
        </b-form-checkbox>
      </div>
    </b-collapse>
    <hr />
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import 'vue-slider-component/theme/material.css';
import ExpressionGroup from '@/components/notifications/settings/ExpressionGroup';
import Member from '@/components/notifications/settings/Member';
import config from '@/config';
import axios from 'axios';


export default {
  name: 'Item',
  props: {
    notification: {
      required: true,
      type: Object,
    },
    collapsed: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      emailLoading: false,
      pushLoading: false,
      enableLoading: false,
      subscription: {
        email: false,
        push_notification: false,
        enabled: false,
      },
      collapsed_: this.collapsed,
      selected: [],
      advancedView: false,
    };
  },
  computed: {
    ...mapState('snapshot', [
      'currentSnapshot',
    ]),
    ...mapGetters('user', [
      'getUserData',
    ]),
    ...mapGetters([
      'getServiceVars',
      'getActorById',
    ]),
    varsByLink() {
      return this.getServiceVars(this.notification.service).reduce((obj, varItem) => {
        obj[varItem.link] = varItem;
        return obj;
      }, {});
    },
    visible() {
      return this.subscription.enabled || !this.collapsed_;
    },
    writableMembers() {
      return Object.values(this.notification.members).filter(member => !member.readonly);
    },
    hasAdvanceMode() {
      return (
        this.getUserData.enable_advance_level || this.getUserData.superuser
      ) && this.getUserData.show_advance_level;
    },
  },
  methods: {
    ...mapActions('notifications', [
      'updateNotification',
      'setNotificationSubscription',
    ]),
    clicked() {
      this.collapsed_ = !this.collapsed_;
    },
    toggleAdvancedView() {
      this.advancedView = !this.advancedView;
    },
    async setEmailSubscription(value) {
      this.emailLoading = true;
      await this.updateSubscription({
        email: value,
        push_notification: this.subscription.push_notification,
        enabled: this.subscription.enabled,
      });
      this.emailLoading = false;
    },
    async setPushSubscription(value) {
      this.pushLoading = true;
      await this.updateSubscription({
        email: this.subscription.email,
        push_notification: value,
        enabled: this.subscription.enabled,
      });
      this.pushLoading = false;
    },
    async setEnabledSubscription(event) {
      this.enableLoading = true;
      await this.updateSubscription({
        email: this.subscription.email,
        push_notification: this.subscription.push_notification,
        enabled: event.value,
      });
      this.enableLoading = false;
    },
    async fetchSubscription() {
      try {
        const response = await axios.get(
          this.$backendUrl(
            config.ICOOL.API.USER_NOTIFICATION_SUBSCRIPTIONS_PATH(
              this.currentSnapshot.id, this.notification.id,
            ),
          ),
        );
        if (response.data.length > 0) {
          [this.subscription] = response.data;
        }
      } catch (err) {
        this.$log.error(err);
      }
    },
    async updateSubscription(data) {
      try {
        const response = await axios.post(
          this.$backendUrl(
            config.ICOOL.API.USER_NOTIFICATION_SUBSCRIPTIONS_PATH(
              this.currentSnapshot.id, this.notification.id,
            ),
          ),
          data,
        );
        this.subscription = response.data;
        this.setNotificationSubscription(
          { notification: this.notification, subscription: this.subscription },
        );
      } catch (err) {
        this.$log.error(err);
      }
    },
  },
  mounted() {
    this.fetchSubscription();
    this.updateNotification(this.notification);
  },
  components: {
    Member,
    ExpressionGroup,
  },
};
</script>

<style scoped>

</style>
